var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { FormFailedIconMessage } from '../FormFailedIconMessage';
import { formFieldCss } from '../../utils';
import '../../styles/FormField.scss';
export const FormInput = (_a) => {
    var { label, className, validation, type = 'text' } = _a, rest = __rest(_a, ["label", "className", "validation", "type"]);
    const { blockClassName, labelClassName, inputClassName, validationClassName, } = formFieldCss({
        customClass: className,
        isInvalid: validation === null || validation === void 0 ? void 0 : validation.isInvalid,
    });
    return (React.createElement("label", { className: blockClassName },
        label ? React.createElement("span", { className: labelClassName }, label) : null,
        React.createElement("input", Object.assign({ className: inputClassName, type: type }, rest)),
        React.createElement("div", { className: validationClassName },
            React.createElement(FormFailedIconMessage, { message: validation === null || validation === void 0 ? void 0 : validation.message, isActive: validation === null || validation === void 0 ? void 0 : validation.isInvalid }))));
};
//# sourceMappingURL=FormInput.js.map